import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight, Download } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
export function OfferCTA() {
  return <div className="py-20 bg-cream-dark relative overflow-hidden" data-id="element-74">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-terracotta/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-75" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-sage/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-76" />

      <Section className="relative z-10" data-id="element-77">
        <div id="oferta" className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-cream-dark text-center max-w-3xl mx-auto" data-id="element-78">
          <div className="inline-block px-4 py-1 bg-terracotta/10 text-terracotta rounded-full text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-79">
            Oferta Especial
          </div>

          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brown" data-id="element-80">
            Reset 4 Pilares (30 días)
          </h2>
          <p className="text-xl text-brown-light mb-8" data-id="element-81">
            Energía + Enfoque + Cuerpo + Rumbo
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-12" data-id="element-82">
            <div className="w-48 md:w-56 transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/1qSJmLuRrj24iVViJipter/reset_4_pilares_mockup.png" alt="Product Mockup" className="rounded-xl shadow-lg" data-id="element-84" />
            </div>
            <div className="text-left space-y-4" data-id="element-85">
              <div className="flex items-center gap-3" data-id="element-86">
                <Download className="text-sage" data-id="element-87" />
                <span data-id="element-88">PDF Interactivo + Imprimibles</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-89">
                <span className="text-3xl font-bold text-terracotta" data-id="element-90">
                  $6.36 USD
                </span>
                <span className="text-brown-light line-through decoration-terracotta/50 decoration-2" data-id="element-91">
                  $19.00
                </span>
              </div>
              <p className="text-sm text-brown-light max-w-xs" data-id="element-92">
                Acceso inmediato. Pago único. Tuyo para siempre.
              </p>
            </div>
          </div>

          <a href="https://eficienciadigital.ca/" target="_blank" rel="noopener noreferrer" className="block" onClick={() => trackAddToCart()} data-id="element-93">
            <Button fullWidth className="text-xl py-6 mb-8 group shadow-terracotta/30" data-id="element-94">
              Quiero mi Reset — $6.36 USD
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-95" />
            </Button>
          </a>

          <div className="border-t border-gray-100 pt-8 space-y-6" data-id="element-96">
            <p className="text-lg italic text-brown/80" data-id="element-97">
              "Si sientes que tu vida no avanza… no necesitas otro video.
              Necesitas un sistema que no se rompa cuando el día se rompe."
            </p>
            <p className="font-serif font-bold text-xl text-terracotta" data-id="element-98">
              Haz lo mínimo que cuenta. Y vuelve mañana.
            </p>
          </div>
        </div>
      </Section>
    </div>;
}